// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
var $x = window.$x;
// modified with global simulating transforms: pre, post
// MAGIC_DESPROCKET_END
/* Deprecated, ancient Object Extensions
 *
 * Use underscore and/or just Coffeescript
 * in new code
 */
var $x = {

    // Differs from _.extend in only copying 'own' properties
    extend: function(obj, extras) {
        for (var prop in extras) {
            if (extras.hasOwnProperty(prop)) {
              obj[prop] = extras[prop];
            }
        }
        return obj;
    },

    // Deep clone, taken from http://stackoverflow.com/questions/728360
    clone: function (obj) {
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            var copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            var copy = [];
            for (var i = 0, len = obj.length; i < len; ++i) {
                copy[i] = $x.clone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            var copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = $x.clone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    },

    /* Crockford's object() */

    object: function(o) {
        function F() {}
        F.prototype = o;
        var obj = new F();
        obj._parent = o;
        // since we can't access via protoype
        return obj;
    }

};
// MAGIC_DESPROCKET_START
window.$x = $x;
// MAGIC_DESPROCKET_END
